/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { IncidentFileFieldTypeDto } from './incidentFileFieldTypeDto.schema';

export const IReadOnlyListOfIncidentFileFieldTypeDto = zod.array(zod.lazy(() => IncidentFileFieldTypeDto));

export type IReadOnlyListOfIncidentFileFieldTypeDto = zod.input<typeof IReadOnlyListOfIncidentFileFieldTypeDto>;
export type IReadOnlyListOfIncidentFileFieldTypeDtoOutput = zod.output<typeof IReadOnlyListOfIncidentFileFieldTypeDto>;
